// extracted by mini-css-extract-plugin
export default {"loadingSpinner":"styles_loadingSpinner__5dInv","spinner":"styles_spinner__EqFAA","spinnerContainer":"styles_spinnerContainer__9R-h6"};